import { SLICE_TAG } from '@/constants';
import { ResponseNotificationsSchema } from '@/features/slice/notification/notification.schema';

import { apiSlice } from '../api-slice';

export const notificationApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: (params) => ({
                url: 'notifications',
                method: 'GET',
                params,
            }),
            // keepUnusedDataFor: 120,
            providesTags: [SLICE_TAG.NOTIFICATIONS],
            transformResponse(response) {
                return ResponseNotificationsSchema.parse(response);
            },
        }),

        updateNotificationAsRead: builder.mutation({
            query: (id) => ({
                url: `notifications/${id}/read`,
                method: 'PATCH',
            }),
            invalidatesTags: [SLICE_TAG.NOTIFICATIONS],
        }),

        updateNotificationAsUnread: builder.mutation({
            query: (id) => ({
                url: `notifications/${id}/unread`,
                method: 'PATCH',
            }),
            invalidatesTags: [SLICE_TAG.NOTIFICATIONS],
        }),

        updateAllNotificationsAsRead: builder.mutation({
            query: () => ({
                url: `notifications/read-all`,
                method: 'PATCH',
            }),
            invalidatesTags: [SLICE_TAG.NOTIFICATIONS],
        }),
    }),
});

export const {
    useGetNotificationsQuery,
    useLazyGetNotificationsQuery,
    useUpdateNotificationAsReadMutation,
    useUpdateAllNotificationsAsReadMutation,
    useUpdateNotificationAsUnreadMutation,
} = notificationApiSlice;
